/**
 * API
 */
import {
  axios
} from '@/utils/request'

const baseURL = '/jpaas-jiop-web-server'
function getCookieData (cookieName) {
  try {
    var name = cookieName + '='
    var cookieMsg = document.cookie.replace(/%/g, '%25')
    var decodedCookie = decodeURIComponent(cookieMsg)
    var cookieArray = decodedCookie.split(';')
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i]
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1)
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length)
      }
    }
    return ''
  } catch (err) {
    console.log(err, 'cookieErr')
  }
}
// 使用示例
const token = getCookieData('accessToken')
const api = {
  findMaterialByIids: baseURL + '/interface/information/findMaterialByIids', // 查询事项表单
  // 判断是否登录
  isLogin: baseURL + '/interface/buttjoint/jisbuttsuccess',
  // 获取登录页面url
  getLoginUrl: baseURL + '/interface/buttjoint/jisurl',
  // 获取事项步骤配置
  findReportConfigByIid: baseURL + '/interface/reportconfig/findReportConfigByIid',
  // 查询办件获取短信验证码
  getVerifyCode: baseURL + '/interface/verify/getVerifyCode',
  // 确认页提交办件
  formSubmit: baseURL + '/interface/handling/formSubmit',
  findHandlingDetail: baseURL + '/interface/handling/findHandlingDetail', // 办件详情
  // 提交草稿
  materialSubmit: baseURL + '/interface/draft/formSubmit',
  // 查询验证码是否过期
  verifyCode: baseURL + '/interface/verify/verifyCode',
  // 查询表单提交加密公钥
  getPublicKey: baseURL + '/interface/handling/getPublicKey',
  // 查询元数据
  findMetaData: baseURL + '/front/meta/findMetaData'
}

export const jiopWebAPI = {
  findMetaData (parameter) {
    return axios({
      url: api.findMetaData,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getPublicKey (parameter) {
    return axios({
      url: api.getPublicKey,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findHandlingDetail (parameter) {
    return axios({
      url: api.findHandlingDetail,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findMaterialByIids (parameter) {
    return axios({
      url: api.findMaterialByIids,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  isLogin (parameter) {
    return axios({
      url: api.isLogin,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getLoginUrl (parameter) {
    return axios({
      url: api.getLoginUrl,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  findReportConfigByIid (parameter) {
    return axios({
      url: api.findReportConfigByIid,
      method: 'post',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  getVerifyCode (parameter) {
    return axios({
      url: api.getVerifyCode,
      method: 'post',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  formSubmit (parameter) {
    return axios({
      url: api.formSubmit,
      method: 'post',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  materialSubmit (parameter) {
    return axios({
      url: api.materialSubmit,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  verifyCode (parameter) {
    return axios({
      url: api.verifyCode,
      method: 'post',
      data: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  }

}
